<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="isVisible"
      max-width="500"
    >
      <v-card>
        <v-card-title
          class="headline text-md-center"
          primary-title
        >
          Delete Legal Entity
        </v-card-title>

        <v-card-text light>
          <p><strong>Delete Legal Entity</strong>: <code>{{ legalEntityId }}</code></p>
          <p><v-divider /></p>
          <p>Are you sure you want to delete the Legal Entity?</p>
          <p>This step can't be reverted.</p>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="secondary"
            flat
            @click="isVisible = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="error"
            flat
            @click="() => { isVisible = false; $emit('submit') }"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'DeleteDialog',
  components: {
  },
  props: {
    visible: Boolean,
    legalEntityId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit('close');
        }
      },
    },
  },
};
</script>
<style lang="scss" />



// WEBPACK FOOTER //
// src/components/payoutsAndTaxes/payout/dialogs/legalEntity/DeleteDialog.vue